type FormatDateOptions = { includeTime?: boolean };

const ISO_DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

export const formatDate = (
  value: Date | string | null | undefined,
  options?: FormatDateOptions,
): string => {
  if (!value) return '';
  const dateOnlyMatch = typeof value === 'string' ? ISO_DATE_ONLY.exec(value) : null;
  const date =
    dateOnlyMatch === null
      ? value instanceof Date
        ? value
        : new Date(value)
      : new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]));
  if (Number.isNaN(date.valueOf())) return '';
  if (options?.includeTime) {
    return date.toLocaleString('en-GB', {
      ...dateFormatOptions,
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
    });
  }
  return date.toLocaleDateString('en-GB', dateFormatOptions);
};
